var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FE5D86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.08444C4.5 4.76156 4.7655 4.5 5.09287 4.5H9.36112C11.8789 4.5 12.7671 4.797 13.3791 5.40056C13.5683 5.59279 13.7152 5.82256 13.8101 6.07505C13.9051 6.32754 13.946 6.59714 13.9303 6.86644C13.9303 7.90762 13.3695 8.61356 11.8564 8.9235C13.3177 9.17887 14.0597 9.77287 14.0597 10.9676C14.0736 11.2463 14.0298 11.5248 13.931 11.7857C13.8323 12.0467 13.6808 12.2844 13.4859 12.4841C12.8869 13.0747 11.9081 13.5 9.27394 13.5H5.09287C4.93677 13.501 4.78664 13.4401 4.67547 13.3305C4.5643 13.2209 4.50119 13.0717 4.5 12.9156V5.08444ZM7.74056 8.43806C7.74056 8.22263 7.91775 8.04825 8.136 8.04825H9.51019C10.2943 8.04825 10.881 8.01 11.1527 7.72875C11.216 7.66231 11.2648 7.58346 11.2961 7.4972C11.3273 7.41093 11.3404 7.31912 11.3344 7.22756C11.3512 7.04756 11.2905 6.86869 11.1656 6.73537C10.89 6.46425 10.3039 6.41644 9.51019 6.41644H6.9525V11.6094H9.48375C10.3455 11.6094 10.9839 11.5453 11.2821 11.2483C11.4193 11.1077 11.4902 10.9164 11.4767 10.7212C11.4891 10.5227 11.4187 10.3275 11.2821 10.1813C10.9806 9.88481 10.3427 9.86231 9.48375 9.86231H8.145C8.09135 9.86364 8.03798 9.85411 7.9881 9.8343C7.93822 9.81448 7.89286 9.78479 7.85475 9.747C7.81692 9.70965 7.7872 9.66489 7.76746 9.61553C7.74771 9.56617 7.73836 9.51326 7.74 9.46013L7.74056 8.43806Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrd);
export default __webpack_public_path__ + "static/media/brd.bd5c5c960257033b43346d1a76330009.svg";
export { ForwardRef as ReactComponent };